import { Navigate } from 'react-router-dom';
import {
  getAuthenticated,
  isLocalSeoUser,
  localStorageMethod
} from 'src/common/config/FunctionHelper';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from 'src/redux/store';
import { paths, userRoles } from './config/TextMessage';
import { hasLocalSeoCookie } from './config/FunctionHelperPartTwo';

const ProtectedRoutes = ({ children }) => {
  // Clear GSCType local storage
  localStorageMethod('remove', 'GSCType');
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const isOldPlan = stripeSubscriptionDetails?.planVersion == 'v1'
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  // Check if the site audit loader is active
  const loader =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency = activePlanName === planDetails?.agency;
  const isExpertPlus = activePlanName === planDetails?.expertPlus;

  const isSubscription = !stripeSubscriptionDetails
    ? null
    : stripeSubscriptionDetails['subscription_id'] !== undefined
    ? true
    : false;

  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};

  // Check if the user's email is restricted
  const restrictedRoute = userDetails?.role_type === userRoles?.member;
  const isDiyOrFreePlan =
    activePlanName === planDetails?.starterPlus || activePlanName === planDetails?.diy || activePlanName === planDetails?.free;
  const isFreePlan = activePlanName === planDetails?.free;
  let location = useLocation();

  const isAuthenticated: any = getAuthenticated();

  const isAllowRouteAdmin = ['/user-management', '/billing'];
  const isAllowLocalSeoUserRoutes = [
    //'/local-seo',
    '/billing',
    '/settings',
    '/local-seo/business-profile',
    '/google-business',
    '/local-seo/map-rank-tracker',
    '/local-seo/tasks',
    '/local-seo/google-reviews',
    '/local-seo/business-posts',
    '/local-seo/listing-manager',
    //'/local-seo/citation-builder',
    '/try-seospace',
    paths?.googleReviewsEmbed,
    paths?.googleReviewsWidget
  ];
  const isKeywordResearchSubPaths = [
    paths?.blogPostIdeas,
    paths?.competitorAnalysis,
    paths?.keywordOverview,
    paths?.keywordsLists,
    paths?.keywordTracking
  ];
  const isOrbitAiSubPaths = [
    paths?.keywordAssist,
    paths?.blogPostAgent,
    paths?.contentStrategy,
    paths?.contentPlan,
    paths?.localSeoAi,
    paths?.reviewAutomation
  ];
  const isLocalSeoSubPaths = [
    paths?.localChecker,
    paths?.googleBusiness,
    paths?.mapRankTracker,
    paths?.localTasks,
    paths?.googleReviews,
    paths?.businessPosts,
    paths?.listingManager,
    paths?.citationBuilder,
    paths?.googleReviewsWidget,
    paths?.googleReviewsEmbed
  ];
  let isExpirePlanPaths = [paths?.billing, paths?.dashboard, paths?.settings];
  const isNoPlanAccount =
    !stripeLoader &&
    !loader &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loader &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;
  const isPausedAccount = stripeSubscriptionDetails?.pause_collection?.behavior;
  const isLocalSeo = isLocalSeoUser() || hasLocalSeoCookie();
  const isEnterprise = activePlanName === planDetails?.enterprise;

  if (stripeLoader) {
    return <></>;
  }
  if (isLocalSeo) {
    isExpirePlanPaths = [paths?.billing, paths?.settings];
  }
  if (
    isAuthenticated == 'true' &&
    isPausedAccount &&
    !isExpirePlanPaths.includes(location?.pathname)
  ) {
    return (
      <Navigate to={isLocalSeo ? paths?.billing : paths?.dashboard} replace />
    );
  } else if (
    isAuthenticated == 'true' &&
    !isAllowLocalSeoUserRoutes.includes(location?.pathname) &&
    isLocalSeo
  ) {
    return (
      <Navigate
        to={
          isNoPlanOrExpire || isPausedAccount
            ? paths?.billing
            : paths?.localChecker
        }
        replace
      />
    );
  } else if (
    isAuthenticated == 'true' &&
    isNoPlanOrExpire &&
    !isExpirePlanPaths.includes(location?.pathname)
  ) {
    return (
      <Navigate to={isLocalSeo ? paths?.billing : paths?.dashboard} replace />
    );
  } else if (isAuthenticated == 'true' && location?.pathname == paths?.signup) {
    return <Navigate to={paths?.dashboard} replace />;
  } else if (
    isAuthenticated == 'true' &&
    isKeywordResearchSubPaths.includes(location?.pathname) &&
    (isFreePlan || isLocalSeo)
  ) {
    return <Navigate to={paths?.keywordResearch} replace />;
  } else if (
    isAuthenticated == 'true' &&
    isOrbitAiSubPaths.includes(location?.pathname) &&
    (isFreePlan || isLocalSeo)
  ) {
    return <Navigate to={paths?.orbitAiAgent} replace />;
  } else if (
    isAuthenticated == 'true' &&
    isLocalSeoSubPaths.includes(location?.pathname) &&
    isFreePlan
  ) {
    return <Navigate to={paths?.otherTools} replace />;
  } else if (
    isAuthenticated == 'true' &&
    isAllowRouteAdmin.includes(location?.pathname) &&
    restrictedRoute
  ) {
    return (
      <Navigate to={isLocalSeo ? paths?.billing : paths?.dashboard} replace />
    );
  }
  else if (
    isAuthenticated == 'true' &&
    location?.pathname?.toLowerCase() == paths?.memberSignup
  ) {
    return <Navigate to={paths?.dashboard} replace />;
  } else if (
    (isAuthenticated == 'false' || isAuthenticated == null) &&
    location?.pathname?.toLowerCase() == paths?.memberSignup
  ) {
    return children;
  } else if (
    isAuthenticated == 'true' &&
    location?.pathname == paths?.userManagement &&
    isDiyOrFreePlan
  ) {
    return <Navigate to={paths?.dashboard} replace />;
  } else if (isAuthenticated == 'true' && location?.pathname == paths?.leadGeneration &&
    (isOldPlan ? (isSubscription && !isAgency && !isExpertPlus && !isEnterprise) : isFreePlan)) {
    return <Navigate to={paths?.dashboard} replace />;
  } else if (
    (isAuthenticated == 'false' || isAuthenticated == null) &&
    location?.pathname == paths?.signup
  ) {
    return children;
  } else if (isAuthenticated == 'false' || isAuthenticated == null) {
    return <Navigate to={paths?.signin} replace />;
  } else if (
    isAuthenticated == 'true' &&
    location?.pathname == paths?.trySeoSpace &&
    !isLocalSeo
  ) {
    return <Navigate to={paths?.dashboard} replace />;
  } else {
    return children;
  }
};

export default ProtectedRoutes;
